require("./bootstrap");

import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";

import Vue from "vue";
import { createInertiaApp, Link } from "@inertiajs/inertia-vue";
import Layout from "./Shared/Layout";
import Guest from "./Shared/Guest";

createInertiaApp({
    resolve: async (name) => {
        let page = (await import(`./Pages/${name}`)).default;

        if (page.layout === undefined) {
            page.layout = Layout;
        } else if (page.layout === 'Guest') {
            page.layout = Guest;
        }

        return page;
    },
    setup({ el, App, props, plugin }) {
        Vue.use(plugin).mixin({methods: {route}}).component("Link", Link);

        new Vue({
            render: (h) => h(App, props),
        }).$mount(el);
    },
    title: (title) => `${title} - Synthesis`,
});

import moment from "moment";

Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("D MMM YYYY");
    }
});

Vue.filter("formatDateTime", function (value) {
    if (value) {
        return moment(String(value)).format("hh:mmA, D MMM YYYY");
    }
});

import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);
import "vue-multiselect/dist/vue-multiselect.min.css";

import Vue2Filters from "vue2-filters";
Vue.use(Vue2Filters);

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);


